/* ============================================================================
   RK BEWEGUNG — Parallax und Auftritte beim Scrollen

   Zwei Dinge, ein Skript, ein einziger rAF-Takt:

   · data-rk-parallax="0.3"  verschiebt ein Element langsamer als die Seite.
     Bewusst über transform statt background-attachment: fixed — das ruckelt
     auf Mobilgeräten und wird von iOS Safari schlicht ignoriert.

   · data-rk-auftritt="hoch|links|rechts|zoom|maske"  blendet ein Element ein,
     wenn es in den Blick kommt. Verschiedene Richtungen, damit nicht jede
     Section gleich hereinfährt.

   Wer Bewegung reduziert hat, bekommt alles sofort und ruhig zu sehen.
   ========================================================================= */
(function () {
  'use strict';

  var ruhig = window.matchMedia('(prefers-reduced-motion: reduce)');

  // ---- Auftritte ---------------------------------------------------------

  /* Staffelung: Statt den ganzen Abschnitt als Block hereinzufahren, treten
     seine Kacheln nacheinander auf. Das wirkt lebendiger und kostet weniger
     — ein weichgezeichneter Abschnitt über die volle Breite ist teuer, eine
     Kachel nicht. */
  function staffelnVorbereiten() {
    document.querySelectorAll('[data-rk-staffel]:not([data-rk-gestaffelt])').forEach(function (gruppe) {
      gruppe.setAttribute('data-rk-gestaffelt', '1');
      var art = gruppe.getAttribute('data-rk-staffel') || 'hoch';
      var schritt = parseInt(gruppe.getAttribute('data-rk-schritt') || '70', 10);
      var kinder = [].slice.call(gruppe.children);

      kinder.forEach(function (kind, i) {
        if (kind.hasAttribute('data-rk-auftritt')) return;
        kind.setAttribute('data-rk-auftritt', art);
        /* Nach dem achten Kind keine weitere Verzögerung — sonst wartet man
           bei einem großen Raster sekundenlang auf die letzte Kachel. */
        kind.setAttribute('data-rk-verzug', String(Math.min(i, 7) * schritt));
      });
    });
  }

  /* EIN Beobachter fuer die ganze Seite, angelegt auf Modulebene.

     Vorher entstand er in auftritteStarten() als lokale Variable. Lief die
     Funktion ein zweites Mal - im Theme-Editor bei jedem
     shopify:section:load, im Laden bei jedem nachgeladenen Inhalt -, verlor
     der erste Beobachter seine letzte Referenz und wurde eingesammelt. Alle
     Abschnitte, die er bis dahin beobachtete, warteten dann auf ein Signal,
     das niemand mehr sendete, und blieben unsichtbar stehen. */
  var beobachter = null;

  function beobachterHolen() {
    if (beobachter) return beobachter;
    beobachter = new IntersectionObserver(function (eintraege) {
      eintraege.forEach(function (eintrag) {
        if (!eintrag.isIntersecting) return;
        var e = eintrag.target;
        var verzug = parseInt(e.getAttribute('data-rk-verzug') || '0', 10);
        setTimeout(function () { e.classList.add('ist-da'); }, verzug);
        beobachter.unobserve(e);
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.08 });
    return beobachter;
  }

  function auftritteStarten() {
    staffelnVorbereiten();
    var ziele = [].slice.call(document.querySelectorAll('[data-rk-auftritt]:not([data-rk-bereit])'));
    if (!ziele.length) return;

    ziele.forEach(function (e) { e.setAttribute('data-rk-bereit', '1'); });

    if (ruhig.matches || !('IntersectionObserver' in window)) {
      ziele.forEach(function (e) { e.classList.add('ist-da'); });
      return;
    }

    /* Was beim Start schon im Bild steht, wird NIE versteckt.

       Vorher bekam jedes Ziel den Wartezustand - auch das Produktbild oben
       auf der Produktseite und das Kategoriebild. Der Browser hatte es dann
       schon gemalt, das Skript versteckte es wieder, und eingeblendet wurde
       es erst, wenn das Skript zwischen den App-Skripten drankam. Gemessen
       (Lighthouse, Handy): Bild nach 0,7 s geladen, aber erst nach 17,8 s
       zu sehen. Fuer Google zaehlt das letzte Malen - die Seite galt damit
       als 18 Sekunden langsam. Einen Auftritt fuer etwas, das man beim
       Oeffnen sofort sieht, nimmt ohnehin niemand wahr. */
    var hoehe = window.innerHeight || document.documentElement.clientHeight;
    var offen = [];
    ziele.forEach(function (e) {
      var r = e.getBoundingClientRect();
      if (r.top < hoehe && r.bottom > 0) {
        e.classList.add('ist-da');
      } else {
        e.classList.add('wartet');
        offen.push(e);
      }
    });
    if (!offen.length) return;

    var ob = beobachterHolen();
    offen.forEach(function (e) { ob.observe(e); });
    netzSpannen();
  }

  /* Sicherheitsnetz.

     Der Beobachter misst die sichtbare Flaeche - und die wird vom
     Wartezustand mitbestimmt. Ein Auftritt, der sein Element verdeckt
     (clip-path zaehlt in die Schnittflaeche hinein), kann den Beobachter
     blind machen: er wartet dann auf ein Signal, das nicht mehr kommen
     kann. Genau das ist beim Lookbook passiert.

     Diese Pruefung misst nur Geometrie. Die ist unabhaengig davon, wie ein
     Element dargestellt wird, und faengt jeden Fall dieser Art ab - auch
     kuenftige. */
  var netzLaeuft = false;

  function netzPruefen() {
    netzLaeuft = false;
    var offen = [].slice.call(
      document.querySelectorAll('[data-rk-auftritt][data-rk-bereit]:not(.ist-da)')
    );
    if (!offen.length) return;
    offen.forEach(function (e) {
      var r = e.getBoundingClientRect();
      if (r.top < window.innerHeight * 0.92 && r.bottom > 0) {
        var verzug = parseInt(e.getAttribute('data-rk-verzug') || '0', 10);
        setTimeout(function () { e.classList.add('ist-da'); }, verzug);
      }
    });
  }

  function netzAnstossen() {
    if (netzLaeuft) return;
    netzLaeuft = true;
    window.requestAnimationFrame(netzPruefen);
  }

  var netzGespannt = false;

  function netzSpannen() {
    /* Einmal nach dem Laden, fuer alles, was schon beim Aufschlagen im
       Blick steht - auch bei spaeter nachgeladenen Inhalten. */
    setTimeout(netzPruefen, 1200);
    if (netzGespannt) return;
    netzGespannt = true;
    window.addEventListener('scroll', netzAnstossen, { passive: true });
    window.addEventListener('resize', netzAnstossen, { passive: true });
  }

  // ---- Parallax ----------------------------------------------------------

  var schichten = [];
  var laeuft = false;

  function schichtenSammeln() {
    schichten = [].slice.call(document.querySelectorAll('[data-rk-parallax]')).map(function (e) {
      return { el: e, tempo: parseFloat(e.getAttribute('data-rk-parallax')) || 0.25 };
    });
  }

  function zeichnen() {
    laeuft = false;
    var mitte = window.innerHeight / 2;

    schichten.forEach(function (s) {
      var r = s.el.getBoundingClientRect();
      /* Nur rechnen, was im Blick ist — alles andere kostet nur Takt. */
      if (r.bottom < -200 || r.top > window.innerHeight + 200) return;
      var abstand = (r.top + r.height / 2) - mitte;
      var weg = Math.round(abstand * s.tempo * -1);
      s.el.style.setProperty('--rk-schub', weg + 'px');
    });
  }

  function anstossen() {
    if (laeuft) return;
    laeuft = true;
    window.requestAnimationFrame(zeichnen);
  }

  function parallaxStarten() {
    if (ruhig.matches) return;
    schichtenSammeln();
    if (!schichten.length) return;
    zeichnen();
    window.addEventListener('scroll', anstossen, { passive: true });
    window.addEventListener('resize', function () { schichtenSammeln(); anstossen(); }, { passive: true });
  }

  /* Videos mit Autoplay bekommen ihre Quelle erst kurz bevor sie ins Bild
     kommen. Mit autoplay im HTML laedt der Browser sofort die ganze Datei. */
  function videosSpaet() {
    var videos = [].slice.call(document.querySelectorAll('video[data-rk-video-spaet]:not([data-rk-video-bereit])'));
    if (!videos.length) return;
    function starten(v) {
      v.setAttribute('data-rk-video-bereit', '1');
      [].slice.call(v.querySelectorAll('source[data-src]')).forEach(function (q) {
        q.src = q.getAttribute('data-src');
        q.removeAttribute('data-src');
      });
      v.load();
      if (!ruhig.matches) {
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
      } else {
        v.controls = true;
      }
    }
    if (!('IntersectionObserver' in window)) { videos.forEach(starten); return; }
    var ob = new IntersectionObserver(function (eintraege) {
      eintraege.forEach(function (e) {
        if (!e.isIntersecting) return;
        ob.unobserve(e.target);
        starten(e.target);
      });
    }, { rootMargin: '400px 0px' });
    videos.forEach(function (v) { ob.observe(v); });
  }

  function alles() {
    auftritteStarten();
    parallaxStarten();
    videosSpaet();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', alles);
  } else {
    alles();
  }

  // Im Theme-Editor neu verdrahten.
  document.addEventListener('shopify:section:load', alles);

  /* Inhalte, die erst später kommen — nachgeladene Produkte, Empfehlungen —
     melden sich hiermit. Ohne das blieben sie ohne Auftritt und ohne
     Staffelung stehen, während alles um sie herum sich bewegt. */
  document.addEventListener('rk:inhalt-neu', function () {
    auftritteStarten();
    schichtenSammeln();
    anstossen();
  });

  // Schaltet jemand Bewegung mitten im Besuch ab, hört das Schieben auf.
  if (ruhig.addEventListener) {
    ruhig.addEventListener('change', function () {
      if (!ruhig.matches) return;
      window.removeEventListener('scroll', anstossen);
      schichten.forEach(function (s) { s.el.style.removeProperty('--rk-schub'); });
      document.querySelectorAll('[data-rk-auftritt]').forEach(function (e) {
        e.classList.remove('wartet');
        e.classList.add('ist-da');
      });
    });
  }
})();
